module.exports = __webpack_public_path__ + "img/no_pxrw.0acc4213.png";